import { render, staticRenderFns } from "./privilegeGoods.vue?vue&type=template&id=5930b2ec&scoped=true&"
import script from "./privilegeGoods.vue?vue&type=script&lang=js&"
export * from "./privilegeGoods.vue?vue&type=script&lang=js&"
import style0 from "./privilegeGoods.vue?vue&type=style&index=0&id=5930b2ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5930b2ec",
  null
  
)

export default component.exports